import 'vite/modulepreload-polyfill' 
import LessonViewerApp from './LessonViewerApp.vue'
import { EmurseAppFactory, EmurseAppRegistration, EmurseStartup, type IAppData } from '@/EmurseStartup';
import { CourseRepository } from '@/data/repository/CourseRepository';
import { DictionaryRepository } from '@/data/repository/DictionaryRepository';
import { EntryRepository } from '@/data/repository/EntryRepository'; 
import { ProgressRepository } from '@/data/repository/ProgressRepository';
import { UnlockRepository } from '@/data/repository/UnlockRepository';
import { DashboardRepository } from '@/data/repository/DashboardRepository';
import { WordlistRepository } from '@/data/repository/WordlistRepository';
 
EmurseAppFactory.registerApp(new EmurseAppRegistration("lesson",(appData: IAppData)=>
{
  const startupData= {app: LessonViewerApp,
    appData:appData,
    repositories:{
      courseRepository: CourseRepository,
      dictionaryRepository: DictionaryRepository,
      dashboardRepository: DashboardRepository,
      entryRepository: EntryRepository,      
      wordlistRepository: WordlistRepository, 
      progressRepository: ProgressRepository,
      unlockRepository: UnlockRepository
       }
      }; 
  const startup = new EmurseStartup(startupData);
}));  